export default {
    title: 'OX 퀴즈',
    answer: '정답',
    explanation: '해설',
    correctChoice: {
        true: '참',
        false: '거짓',
    },
};
